/* 该文件存放所有请求的url */
const BASE_URL = 'https://www.njzhny.com:8443' // 基础url(网管服务器)
const BASE_ORDER_URL = 'https://www.njzhny.com:8443/order' // 订单管理微服务url

/* 登录注册退出 */
const LOGIN_URL = BASE_URL + '/auth/login'
const REGISTER_URL = BASE_URL + '/auth/signup'
const LOGOUT_URL = BASE_URL + '/auth/logout'

// 管理员操作订单
const ORDER_TABLE_LIST_URL = BASE_ORDER_URL + '/manager/order/query/page' // 获取订单管理列表url
const ORDER_STATUS_CHANGE_URL = BASE_ORDER_URL + '/manager/order/pending' // 改变订单状态为待收货

// 商户操作
const ORDER_BUSSINESS_TABLE_LIST_URL = BASE_ORDER_URL + '/business/query/page' // 获取订单管理列表url
const ORDER_BUSSINESS_STATUS_CHANGE_URL = BASE_ORDER_URL + '/business/pending' // 修改订单状态

/* 商品操作 */
const GET_SHOPID_NAME_LIST_URL = 'https://www.njzhny.com:8443/product/business/shop/findAllShop' // 根据用户名获取店铺名
const GET_TABLE_LIST_URL = 'https://www.njzhny.com:8443/product/business/product/findAll'// 根据店铺名获取表格列表
const ADD_CATEGORIES_URL = 'https://www.njzhny.com:8443/product/business/product/SaveProduct'// 增加一条商品
const CHANGE_CATEGORIES_STATUS_URL = 'https://www.njzhny.com:8443/product/business/product/set_sale_status' // 改变订单状态
const DELETE_CATEGORIES_URL = 'https://www.njzhny.com:8443/product/business/product/deleteById' // 根据指定id删除订单

/* 店铺管理 */
// const GET_SHOPID_NAME_LIST_URL = 'https://www.njzhny.com:8443/product/business/shop/findAllShop/' // 查询用户所有店铺
const ADD_SHOP_URL = 'https://www.njzhny.com:8443/product/business/shop/SaveShop' // 新增店铺
const DELETE_SHOP_URL = 'https://www.njzhny.com:8443/product/business/shop/deleteById' // 根据指定id删除店铺

/* 图片管理 */
const PHOTO_FIND_URL = 'https://www.njzhny.com:8443/product/business/productImg/findById' // 查询商品图片
const PHOTO_ADD_URL = 'https://www.njzhny.com:8443/product/business/productImg/addImg' // 查询商品ID新增商品图片详情
const PHOTO_DEL_URL = 'https://www.njzhny.com:8443/product/business/productImg/deleteImgById' // 查询图片ID删除图片

/* 地址管理 */
const ADDRESS_LIST_URL = BASE_URL + '/user/users/shopshipping/list'
const ADD_ADDRESS_URL = BASE_URL + '/user/users/shopshipping/add'
const DELETE_ADDRESS_URL = BASE_URL + '/user/users/shopshipping/delete'
const UPDATE_ADDRESS_URL = BASE_URL + '/user/users/shopshipping/modify'
const ADDRESS_ID_LIST_URL = BASE_URL + '/user/users/shopshipping/info'

module.exports = {
    LOGIN_URL,
    REGISTER_URL,
    LOGOUT_URL,
    ORDER_TABLE_LIST_URL,
    ORDER_STATUS_CHANGE_URL,
    ORDER_BUSSINESS_TABLE_LIST_URL,
    ORDER_BUSSINESS_STATUS_CHANGE_URL,
    GET_SHOPID_NAME_LIST_URL,
    GET_TABLE_LIST_URL,
    ADD_CATEGORIES_URL,
    CHANGE_CATEGORIES_STATUS_URL,
    DELETE_CATEGORIES_URL,
    ADD_SHOP_URL,
    DELETE_SHOP_URL,
    // GET_SHOPID_NAME_LIST_URL,
    PHOTO_FIND_URL,
    PHOTO_ADD_URL,
    PHOTO_DEL_URL,
    ADDRESS_LIST_URL,
    ADD_ADDRESS_URL,
    DELETE_ADDRESS_URL,
    UPDATE_ADDRESS_URL,
    ADDRESS_ID_LIST_URL
}
